// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.time-picker-component__time-range {
  margin-top: 1px;
  display: flex;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  width: 272px;
  height: 51px;
  padding-right: 5px;
}
.time-picker-component__icon-left {
  padding: 15px 6px;
  padding-right: 0;
}
.time-picker-component__icon-right {
  padding: 15px 0 0px 15px;
}
.time-picker-component__input {
  border: none;
  padding-left: 5px;
  margin-right: 5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.time-picker-component__input-right {
  border: none;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.time-picker-component__dash-icon {
  margin-top: 12px;
}`, "",{"version":3,"sources":["webpack://./src/screens/scheduleModification/time-picker/time-picker.scss"],"names":[],"mappings":"AACI;EACA,eAAA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,YAAA;EACA,YAAA;EACA,kBAAA;AADR;AAII;EACI,iBAAA;EACA,gBAAA;AAFR;AAKI;EACI,wBAAA;AAHR;AAMI;EACI,YAAA;EACA,iBAAA;EACA,iBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AALR;AAQI;EACI,YAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAPR;AAUI;EACI,gBAAA;AARR","sourcesContent":[".time-picker-component {\n    &__time-range {\n    margin-top: 1px;\n        display: flex;\n        background: #ffffff;\n        border: 1px solid #e9e9e9;\n        border-radius: 8px;\n\n        width: 272px;\n        height: 51px;\n        padding-right: 5px;\n    }\n\n    &__icon-left {\n        padding: 15px 6px; \n        padding-right: 0;\n    }\n\n    &__icon-right {\n        padding: 15px 0 0px 15px;\n    }\n\n    &__input {\n        border: none;\n        padding-left: 5px;\n        margin-right: 5px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        color: #333333;\n    }\n\n    &__input-right {\n        border: none;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        color: #333333;\n    }\n\n    &__dash-icon {\n        margin-top: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
